<template>
  <b-row>
    <b-col cols="12">
      <candidate-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CandidateEditForm from './CandidateEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    CandidateEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
